import { apiStore } from '../../modules/apiHelper';

export default {
  addMenteeRequest(state, data) {
    if (!state.menteeRequests.find(m => m.id === data.id)) {
      state.menteeRequests.unshift(data);
    }
  },
  removeMenteeRequest(state, linkId) {
    const index = state.menteeRequests.findIndex(m => m.linkid === linkId);

    if (index >= 0) {
      // console.log('removing mentee request', state.menteeRequests[index]);
      state.menteeRequests.splice(index, 1);
    }
  },
  addMentee(state, data) {
    if (!state.mentees.find(m => m.id === data.id)) {
      state.mentees.unshift(data);
      apiStore.setItem('mymentees', state.mentees);
    }
  },
  removeMentee(state, menteeId) {
    const index = state.mentees.findIndex(r => r.id === menteeId);

    if (index >= 0) {
      state.mentees.splice(index, 1);
      apiStore.setItem('mymentees', state.mentees);
    }
  },
  updateMentee(state, { id, prop, value }) {
    const index = state.mentees.findIndex(m => m.id === id);

    if (index >= 0) {
      // console.log('updating mentee ', prop, state.mentees.find(m => m.id === id));
      state.mentees[index][prop] = value;
      apiStore.setItem('mymentees', state.mentees);
    }
  },
  addMentorGoal(state, goalid) {
    if (!state.goals.find(g => g === goalid)) {
      // console.log('adding mentor goal');
      state.goals.push(goalid);
    }
  },
  removeMentorGoal(state, goalid) {
    const index = state.goals.indexOf(goalid);

    if (index >= 0) {
      state.goals.splice(index, 1);
    }
  },
  clearMentorData(state) {
    state.mentees = [];
    state.goals = [];
    apiStore.removeItem('mentorgoals');
  },
};
